import { ToastrService } from 'ngx-toastr';
import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {FeatureService as Service} from './service';
import {CoreStore} from '../../core/core.store';
import {BaseStateV2} from '../../core/base.state';
import {exhaustMap, map, mergeMap, take, catchError} from 'rxjs/operators';
import {of} from 'rxjs';
import * as FolderStore from '../folder/store';
import {select, Store} from '@ngrx/store';
import {State as AppState} from '../../../reducers';

export const FEATURE_NAME       = 'BOOKMARK';
export const RESOURCE: string   = 'bookmarks';
export const FeatureActions     = new CoreStore.Actions(FEATURE_NAME);


export const initialState: CoreStore.State = CoreStore.initialState;

export function reducer(state = initialState, action: any): any {
    return CoreStore.reducer(state, action, FeatureActions)
}

const selectors = CoreStore.selectors(FEATURE_NAME);

// Effects

@Injectable()
export class Effects {

    private _coreEffectsOptions: CoreStore.EffectsOptions = {
        FEATURE_NAME: FEATURE_NAME,
        Actions: new CoreStore.Actions(FEATURE_NAME),
        featureService: this._svc,
        actions$: this.actions$
    };

    @Effect()
    Load$ = CoreStore.Effects.Load(this._coreEffectsOptions,
        () => RESOURCE);

    @Effect()
    Create$ = CoreStore.Effects.Create(this._coreEffectsOptions,
        (obj) => 'bookmarks?file=' + obj.file
    ).pipe(
        map(data => {
            this.toastrService.success('', 'The item is successfully added to bookmark.',{
                timeOut: 3000
            });
            return data;
        }),
        catchError(error => {
            this.toastrService.error(
                '<b>If the problem persists, please contact an administrator.</b>',
                'An error occured while creating the bookmark. Please try again.',
                {
                    closeButton: true,
                    disableTimeOut: true,
                    enableHtml: true
                }
            );
            return error;
        })
    );

    @Effect()
    Delete$ = CoreStore.Effects.Delete( this._coreEffectsOptions,
        (obj) => 'bookmarks/' + obj.id
    ).pipe(
        map(data => {
            this.toastrService.success('', 'The item is successfully removed from bookmark.', {
                timeOut: 3000
            });
            return data;
        }),
        catchError(error => {
            this.toastrService.error(
                '<b>If the problem persists, please contact an administrator.</b>',
                'An error occured while removing the bookmark. Please try again.',
                {
                    closeButton: true,
                    disableTimeOut: true,
                    enableHtml: true
                }
            );
            return error;
        })
    );

    @Effect()
    ActionSuccess$ = CoreStore.Effects.ActionSuccess(this._coreEffectsOptions);

    @Effect()
    ActionFailure$ = CoreStore.Effects.ActionFailure(this._coreEffectsOptions);

    @Effect()
    SuccessReset$ = CoreStore.Effects.SuccessReset(this._coreEffectsOptions);


    @Effect()
    FlushOnLogout$ = CoreStore.Effects.FlushOnLogout(this._coreEffectsOptions);

    @Effect()
    SuccessReloadBookmarks$ = this.actions$.pipe(
        ofType(FeatureActions.Types.CreateSuccess, FeatureActions.Types.DeleteSuccess),
        map((action: any) => action.payload),
        //tap(() => this.reloadCurrentFolder()),
        mergeMap((bookmarkItem) => [
            new FeatureActions.Load({})
        ])
    );

    @Effect()
    ReloadBookmarksOnFolderCUD$ = this.actions$.pipe(
        ofType(FolderStore.FeatureActions.Types.CreateSuccess,
            FolderStore.FeatureActions.Types.DeleteSuccess,
            FolderStore.FeatureActions.Types.UpdateSuccess),
        exhaustMap(() => of(new FeatureActions.Load({})))
    );


    constructor( protected actions$: Actions<any>,  protected _svc: Service, private _store: Store<AppState>, public toastrService: ToastrService) {}

}

@Injectable()
export class State extends BaseStateV2 {

    FEATURE_NAME: string = FEATURE_NAME;
    FeatureActions: CoreStore.Actions = FeatureActions;
    _selectors = selectors;

}
